import '../styles/Footer.css'; // Add any specific styles

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>© 2024 Jiaqi Wang. All Rights Reserved.</p>
        <p>Designed and developed with ❤️ using React.</p>
        </div>
        <div className="footer-links">
        <p>CONTACT</p>
          <a href="mailto:jiaqiwang097@gmail.com">Email</a>
          <a href="https://github.com/untitledpenguin" target="_blank" rel="noopener noreferrer">GitHub</a>
          <a href="linkedin.com/in/jiaqi-wang-ramis" target="_blank" rel="noopener noreferrer">LinkedIn</a>
        </div>
    </footer>
  );
};

export default Footer;